import { AppSettings } from '@/AppSettings';
import { IThemeCreationOptions } from '@/contexts/styles/ThemeActionContext';
import { ThemeOptions } from '@mui/material/styles';

interface IChangeSizeOptions {
    spacing: number,
    fontSize: number
}

const changeSize = (themeOptions: ThemeOptions, options: IChangeSizeOptions) => {
    themeOptions.spacing = options.spacing;

    if (!themeOptions.typography) {
        themeOptions.typography = {};
    }

    //const typographyOptions = (themeOptions.typography as TypographyOptions);
    //typographyOptions.htmlFontSize = options.fontSize;
    
    const root = document.querySelector<HTMLElement>(':root');

    if (root) {
        root.style.fontSize = `${(options.fontSize / 16 * 100).toFixed(2)}%`;
    }

    return themeOptions;
}

const DefaultBeforeExtraSmallThemeCreated = (themeOptions: ThemeOptions) => {
    return changeSize(themeOptions, {
        spacing: 4,
        fontSize: 8
    });
}

const DefaultBeforeSmallThemeCreated = (themeOptions: ThemeOptions) => {
    return changeSize(themeOptions, {
        spacing: 6,
        fontSize: 12
    });
}

const DefaultBeforeMediumThemeCreated = (themeOptions: ThemeOptions) => {
    return changeSize(themeOptions, {
        spacing: 8,
        fontSize: 14
    });
}

const DefaultBeforeLargeThemeCreated = (themeOptions: ThemeOptions) => {
    return changeSize(themeOptions, {
        spacing: 10,
        fontSize: 16
    });
}

const DefaultBeforeExtraLargeThemeCreated = (themeOptions: ThemeOptions) => {
    return changeSize(themeOptions, {
        spacing: 12,
        fontSize: 18
    });
}

const DefaultBeforeThemeCreated: IThemeCreationOptions['beforeThemeCreated'] = (themeOptions, chosenTheme, chosenThemeSize) => {
    let newOptions: ThemeOptions = {
        ...themeOptions,
        palette: {
            ...themeOptions.palette,
            primary: {
                main: chosenTheme === 'dark' ? AppSettings.palette.primaryDark : AppSettings.palette.primaryLight
            },
            secondary: {
                main: chosenTheme === 'dark' ? AppSettings.palette.secondaryDark : AppSettings.palette.secondaryLight 
            }
        }
    };

    if (chosenTheme !== 'dark') {
        if (!newOptions.palette) {
            newOptions.palette = {}
        }

        newOptions.palette.background = {
            default: '#e9ecef'
        }
    }

    switch (chosenThemeSize) {
        case 'extra-small': newOptions = DefaultBeforeExtraSmallThemeCreated(newOptions);
            break;
        case 'small': newOptions = DefaultBeforeSmallThemeCreated(newOptions);
            break;
        case 'medium': newOptions = DefaultBeforeMediumThemeCreated(newOptions);
            break;
        case 'large': newOptions = DefaultBeforeLargeThemeCreated(newOptions);
            break;
        case 'extra-large': newOptions = DefaultBeforeExtraLargeThemeCreated(newOptions);
            break;
    }

    return newOptions;
};

export default DefaultBeforeThemeCreated;